import Select from 'react-select';
import selectArrow from '../../assets/images/png/select-arrow.png';
import { HeadingDescVsmall } from '../Headings';
import './customSelect2.css';

function CustomSelect2(props) {
  const {
    options,
    name,
    onBlur,
    inputRef,
    value,
    onChange,
    defaultValue,
    placeholder,
    icon,
    text
  } = props;
  return (
    <div className="customSelect2">
      <Select
        options={options}
        defaultValue={defaultValue}
        placeholder={placeholder}
        onChange={onChange}
        value={value}
        name={name}
        onBlur={onBlur}
        inputRef={inputRef}
      />
      {icon || selectArrow ? (
        <img src={icon || selectArrow} className="selectArrow" alt="arrow" />
      ) : (
        ''
      )}
      {text && <HeadingDescVsmall text={text} />}
    </div>
  );
}

export default CustomSelect2;
